import TAGSORT,{taglist} from "../class/tagsort";

const [d] = [document];

const itemTemplate =  `
  <div class="info-list" :class="[ 'is-paged-' + paged ]">
    <ul class="info-list__inner">
      <li v-for="(article , ind) in pagedArticles">
        <a :href="article.href" class="info-list__link">
          <figure>
            <img :src="article.thumb" :alt="article.title" class="case-item__img">
          </figure>
          <p class="cat" v-if="article.category.name">{{ article.category.name }}</p>
          <p class="date">{{ datetostr(article.date * 1000 ,"YYYY.MM.DD")}}</p>
          <p class="title">{{ article.title }}</p>
          <ul class="tags" v-if="article.keywords.length">
            <li v-for="(tag, ind) in article.keywords">#{{ tag }}</li>
          </ul>
        </a>
      </li>
    </ul>
  </div>
  `;

const relatedItemTemplate =  `
  <div class="info-list case-connection-list is-related" v-if="relatedArticles.length">
    <h3 class="info-list__title case-connection-list__title">関連記事</h3>
    <ul class="info-list__inner case-connection-list__inner">
      <li v-for="(article , ind) in relatedArticles">
        <a :href="article.href" class="info-list__link">
          <figure>
            <img :src="article.thumb" :alt="article.title">
          </figure>
          <p class="cat" v-if="article.category.name">{{ article.category.name }}</p>
          <p class="title">{{ article.title }}</p>
          <ul class="tags" v-if="article.keywords.length">
            <li v-for="(tag, ind) in article.keywords">#{{ tag }}</li>
          </ul>
        </a>
      </li>
    </ul>
  </div>
  `;


class taglist_custom extends taglist {
  constructor( opt, parent ) {
    super( opt, parent );
  }
  insertContainer ( tag = `<taglist />`) {
    const tagWrap = d.querySelector( '.info-list__tag-wrap');
    const is_list = d.body.classList.contains('is--list');

    if( is_list && tagWrap ){
      tagWrap.innerHTML = tag;
    }
  }
}

const domReady = () => {
  const is_list = d.body.classList.contains('is--list');
  const listContent = d.querySelector('.info-list__wrap');
  let articlesPerPage = 10; // デフォルト値

  if (listContent && listContent.dataset.countPage) {
    articlesPerPage = parseInt(listContent.dataset.countPage, 10);
  }
  
  const options = {
    list: {
      el: '.info-list__wrap',
      itemTemplate,
      perpage: articlesPerPage,
    },
    taglist: {
      disp_list: is_list ? false : 'both', 
    },
    related: {
      container: '.rwd002-pagination',
      itemTemplate: relatedItemTemplate,
      amount: '3',
      sortType: 'category'
    }
  };

  if (is_list) {
    options.pagination = {
      el: '.info-list__pagination-wrap' 
    };
    options.related.container = '.info-list__pagination-wrap';
  }

  const Tagsort = new TAGSORT(options);

  if (is_list) {
    options.pagination = {
      el: '.info-list__pagination-wrap' 
    };
    options.related.container = '.info-list__pagination-wrap';
  }

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
  });

  // 詳細目次自動出力
  if (!is_list) {
    d.addEventListener('tagsort.afterRender', () => {
      const detailBody = d.querySelector('.info-detail__body');
      if (!detailBody) return;

      const headings = detailBody.querySelectorAll('h3');
      if (headings.length === 0) return;

      if (d.querySelector('.info-detail__toc')) return;

      const tocContainer = d.createElement('div');
      tocContainer.className = 'info-detail__toc-wrap';
      
      let tocHtml = `
        <dl class="info-detail__toc">
          <dt class="info-detail__toc-title">目次</dt>
          <dd class="info-detail__toc-body">
            <ul class="info-detail__toc-list">`;

            headings.forEach((heading, index) => {
              const id = heading.id || `section-${index}`;
              heading.id = id;
              tocHtml += `
                <li class="info-detail__toc-item">
                  <a href="#${id}" class="info-detail__toc-link">${heading.textContent}</a>
                </li>`;
            });

        tocHtml += `</ul></dd></dl>`;
        tocContainer.innerHTML = tocHtml;

      headings[0].parentNode.insertBefore(tocContainer, headings[0]);
    });
  }

  Tagsort.render();
};

export default function INFORMATION () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}